import { render, staticRenderFns } from "./FixedPointCameraSidebar.vue?vue&type=template&id=32a22626"
import script from "./FixedPointCameraSidebar.vue?vue&type=script&lang=js"
export * from "./FixedPointCameraSidebar.vue?vue&type=script&lang=js"
import style0 from "./FixedPointCameraSidebar.vue?vue&type=style&index=0&id=32a22626&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports